import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app-service/app.service';
import { ElearningService } from 'src/app/services/elearning-service/elearning.service';
import { LoginService } from 'src/app/services/login/login.service';
import { UtilService } from 'src/app/services/util-service/util.service';
import { ModalLoginLupaPasswordComponent } from '../modal-login-lupa-password/modal-login-lupa-password.component';
import { ModalWarningComponent } from '../modal-warning/modal-warning.component';
import { PpajInquiryServiceService } from 'src/app/services/ppaj-inquiry-service/ppaj-inquiry-service.service';
import { ModalPengkiniandataComponent } from '../modal-pengkiniandata/modal-pengkiniandata.component';
import { PrivyLivenessService } from 'src/app/services/agent-profile/privy-liveness.service';
import { MENU_CHANGE_FORM_MANAGEMENT } from 'src/app/global-constants/menu-constants';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  hide = true;

  showSpinner = false;

  userForm: FormGroup;
  formErrors = {
    username: '',
    password: ''
  };
  validationMessages = {
    username: {
      required: 'Please enter your agent code',
    },
    password: {
      required: 'please enter your password',
    }
  };
  isLogin = false;

  readonly isStaffDomain = window.location.hostname.endsWith(environment.staffDomainSuffix);

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private appService: AppService,
    private util: UtilService,
    private loginService: LoginService,
    public dialog: MatDialog,
    public dialogLupaPass: MatDialog,
    private elearningService: ElearningService,
    private privyLivenessService: PrivyLivenessService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.userForm.get('loginType').setValue(this.isStaffDomain ? 'STAFF' : 'DIST');
  }

  buildForm() {
    this.userForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      loginType: ['DIST', Validators.required],
    });
  }

  get f() { return this.userForm.controls; }



  login() {
    if (this.userForm.invalid) {
      this.util.validateAllFormFields(this.userForm);
    } else {
      this.showSpinner = true;
      let tmpReq = {
        'data': this.appService.getDataEncryption(this.userForm.getRawValue())
      }

      sessionStorage.setItem("isCandidateAgent", "false");

      this.loginService.processLogin(tmpReq).subscribe((data: any) => {
        if (data['status'] == 'success') {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('IS_DO_COMP');
          // Validate token before storing in sessionStorage (security requirement)
          if (data['token'] && typeof data['token'] === 'string' && data['token'].trim().length > 0) {
            sessionStorage.setItem('token', data['token']);
          }
          this.appService.getUserData({}).subscribe((res) => {
            const data = res['data'];
            if (res['status'] == 'success') {
              if (data['loginAs'] == "AGENCY") {
                if (data['m_user']) {
                  sessionStorage.removeItem('privileges');
                  let privileges = [];
                  data['m_user']['role']['privileges'].forEach(element => {
                    privileges.push(element['name']);
                  });
                  sessionStorage.setItem('privileges', JSON.stringify(privileges));
                  this.router.navigate(['/auth/dashboard']);
                  sessionStorage.removeItem('loginCategory');
                  sessionStorage.setItem('loginCategory', data['m_user']['loginCategory']);
                  sessionStorage.setItem('IS_DO_COMP', data['m_user']['role']['name'] == 'DO Compensation' ? '1' : '0');
                  sessionStorage.setItem('IS_DELETE_ELIGIBLE', data['m_user']['isDeleteEligible'] ? '1' : '0');
                  sessionStorage.setItem('currentAgentCode', data['m_user']['agentCode'] || '');
                  setTimeout(() => { this.pengkinianDataModal(data['m_user'], data['isRevamp'], data['isPengkinian']); }, 1000);

                  if (data['m_user']['loginCategory'] == '01') {
                    this.elearningService.checkUnfinishedTraining(this.f.username.value).subscribe((res_tr: any) => {

                      if (res_tr.status == 'success') {
                        const dataTraining = res_tr.data
                        if (dataTraining.length > 0) {
                          setTimeout(() => {
                            this.callTrainingAlert(dataTraining)
                          }, 1000)
                        }
                      }
                    })
                  }
                }
              } else if (data['loginAs'] == "TM") {
                if (data['tm_user']) {
                  sessionStorage.removeItem('privileges');
                  let privileges = [];
                  if (data['tm_user']['role']) {
                    data['tm_user']['role']['privileges'].forEach(element => {
                      privileges.push(element['name']);
                    });
                  }
                  sessionStorage.setItem('privileges', JSON.stringify(privileges));
                  this.router.navigate(['/auth/dashboard']);
                  sessionStorage.removeItem('loginCategory');
                  sessionStorage.setItem('loginCategory', data['tm_user']['loginCategory']);
                }
              } else if (data['loginAs'] == null) {
                sessionStorage.removeItem('token');
                let errorMessage = 'User not registered! Please register it first!s';
                this.callWarningModal(errorMessage);
                this.showSpinner = false;
              }
            } else {
              this.callWarningModal('Bad Login!');
              this.showSpinner = false;
            }
          });
        } else {
          // let errorMessage = data['message'];
          if (this.userForm.get('loginType').value == 'STAFF') {
            if (data.error) {
              const clientErrException: any = JSON.parse(data.error);
              this.callWarningModal(clientErrException.message);
              this.showSpinner = false;
            } else {
              let errorMessage = 'Username atau password salah';
              this.callWarningModal(errorMessage);
              this.showSpinner = false;
            }
          } else {
            let errorMessage = '';
            if (data['exception'].includes("Silahkan Mengecek Email Anda untuk Verifikasi Link")) {
              errorMessage = 'Silahkan Mengecek Email Anda untuk Verifikasi Link Terlebih Dahulu';
            } else if (data['exception'].includes("Password yang Anda Masukan Salah")) {
              errorMessage = 'Password yang Anda Masukan Salah';
            } else if (data['exception'].includes("User tidak ditemukan")) {
              errorMessage = 'User tidak ditemukan';
            } else if (data['exception'].includes(" License is expired")) {
              errorMessage = 'Agent License is expired. Please contact DO';
            } else {
            let errorMessageArr = data['exception'].split(':');
            let errorCode = errorMessageArr[1]
            let errorMsg = errorMessageArr[2] === " [{\"timestamp\"" ? 'Username atau password salah' : errorMessageArr[2];
            errorMessage = errorCode + "-" + errorMsg;
            }
            this.callWarningModal(errorMessage);
            this.showSpinner = false;
          }
        }
      }, err => {

        // let errorMessage = 'Username isn\'t registered. Please try again';
        let errorMessage = 'Username atau password salah';
        this.callWarningModal(errorMessage);
        this.showSpinner = false;
      });
    }
  }

  callWarningModal(msg: string) {
    const dialogRef = this.dialog.open(ModalWarningComponent, { data: { msg } });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  hideEye() {
    if (this.hide) {
      this.hide = false;
    }
    else {
      this.hide = true;
    }
  }


  callTrainingAlert(trainingList: []) {
    const dialogRef = this.dialog.open(
      ModalWarningComponent,
      {
        data: {
          trainings: trainingList
        }
      })
    dialogRef.afterClosed().subscribe((res: any) => { })
  }

  pengkinianDataModal(mUser: any, isRevamp?: boolean, isPengkinian?: boolean) {
    console.log('pengkinianDataModal called');

    const role = mUser && mUser['role'];
    // const roleCM = new Set(['AGENT', 'AM', 'SAM', 'RAM']);
    const roleName = role && role.name ? role.name.toUpperCase(): '';

    // if (!roleName || !roleCM.has(roleName)) {
    if (!roleName) {
      return;
    }
  

    const privileges: any[] = role['privileges'] || [];
    // const hasPrivilege64 = privileges.some((p: any) => p['name'].includes("Agent Profile - Agent Profile Update Form"));
    const hasPrivilege64 = privileges.some((p: any) => p['name'].includes(MENU_CHANGE_FORM_MANAGEMENT));
    if (!hasPrivilege64) { 
      return; 
    }

    // Gerbang 3 (baru): modal hanya muncul jika isRevamp DAN isPengkinian keduanya false
    if (isRevamp || isPengkinian) {
      return;
    }

    this.dialog.open(ModalPengkiniandataComponent, { data: {}, disableClose: true })
      .afterClosed().subscribe(() => { });
  }

  lupaPasswordModal() {
    console.log("testing")
    this.dialogLupaPass.open(ModalLoginLupaPasswordComponent, {
      width: '250px',
    });
  }

  onboardingBenefit() {
    this.router.navigate(['/onboarding-candidate-agent']);
  }
}


